import { Pipe, PipeTransform } from '@angular/core';
import { MoiCommentType } from '../shared/moi-comment-type.enum';

@Pipe({
    name: 'moiCommentType'
})
export class MoiCommentTypePipe implements PipeTransform {

  transform(commentType: MoiCommentType): string {
    if (!commentType) {
      return "Unspecified";
    }

    return MoiCommentType[commentType].toString().replace(/([A-Z])/g, ' $1');
  }

}
